<template>
  <div>
    <div v-if="colors.length" :class="ui.colorSection">
      <div :class="ui.label">Колір</div>
      <div class="flex flex-wrap gap-2">
        <button
          v-for="c in colors"
          :key="c.value"
          type="button"
          :class="[
            ui.option,
            color === c.value
              ? 'border-black'
              : 'border-gray-200 hover:border-black/50',
          ]"
          :aria-pressed="color === c.value"
          :title="c.label"
          @click.stop.prevent="$emit('update:color', c.value)"
        >
          {{ c.label }}
        </button>
      </div>
    </div>

    <div v-if="sizes.length" :class="ui.sizeSection">
      <div :class="ui.label">Розмір</div>
      <div class="flex flex-wrap gap-2">
        <button
          v-for="s in sizes"
          :key="s.value"
          type="button"
          :class="[
            ui.option,
            size === s.value
              ? 'border-black'
              : 'border-gray-200 hover:border-black/50',
          ]"
          :aria-pressed="size === s.value"
          :title="s.label"
          @click.stop.prevent="$emit('update:size', s.value)"
        >
          {{ s.label }}
        </button>
      </div>
    </div>

    <button
      type="button"
      :class="ui.confirm"
      :disabled="!canSubmit"
      @click.stop.prevent="$emit('confirm')"
    >
      Додати у кошик
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

/**
 * Форма опцій картки (колір/розмір/підтвердження) — спільна для мобільного
 * sheet і десктопного popover у ProductCardPicker. Класи двох шелів навмисно
 * різні (портовані 1:1 зі старого ProductCard) — керуються prop'ом shell.
 */
interface Opt {
  label: string;
  value: string;
}

const props = defineProps<{
  shell: "sheet" | "popover";
  colors: Opt[];
  sizes: Opt[];
  color: string;
  size: string;
  canSubmit: boolean;
}>();

defineEmits<{
  "update:color": [value: string];
  "update:size": [value: string];
  confirm: [];
}>();

const ui = computed(() =>
  props.shell === "sheet"
    ? {
        colorSection: "mb-4",
        sizeSection: "mb-5",
        label: "mb-2 text-sm text-gray-600",
        option: "px-4 h-11 min-w-[44px] rounded-full border text-sm transition",
        confirm:
          "w-full inline-flex h-12 items-center justify-center rounded-full px-4 text-[15px] font-medium bg-pink-200 hover:bg-pink-200/80 active:scale-[.99] disabled:opacity-50",
      }
    : {
        colorSection: "mb-3",
        sizeSection: "mb-3",
        label: "mb-1 text-sm text-gray-600",
        option:
          "px-4 min-h-[44px] rounded-full border text-sm transition inline-flex items-center justify-center",
        confirm:
          "w-full inline-flex h-11 min-w-11 items-center justify-center rounded-full px-3 text-[15px] font-medium bg-pink-200 hover:bg-pink-200/80 active:scale-[.99]",
      },
);
</script>
